import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { useMediaQuery } from "@react-hook/media-query";

const NavigationBar = () => {
  const location = useLocation();
  const navigation = [
    // { name: 'HOME', href: '/', current: location.pathname === '/' },
    { name: "HOME", href: "/", current: location.pathname === "/" },
    {
      name: "DESIGNS",
      href: "/designs",
      current: location.pathname === "/designs",
    },
    { name: "ABOUT", href: "/about", current: location.pathname === "/about" },
    {
      name: "CONTACT",
      href: "/contactUs",
      current: location.pathname === "/contactUs",
    },
  ];

  // State to toggle the mobile navigation menu
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isSmallScreen = useMediaQuery("only screen and (max-width: 670px)");

  useEffect(() => {
    // Add or remove "overflow-hidden" class on the body when the mobile menu is open or closed
    if (isMobileMenuOpen && isSmallScreen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [isMobileMenuOpen, isSmallScreen]);

  return (
    <>
      <div
        className={
          "bg-background mx-auto py-2 px-2 sm:px-6 lg:px-16 sticky  top-0"
        }
      >
        <div className="relative flex h-[60px] items-center justify-between border-b-2">
          <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
            <div className="flex justify-between w-[100%]">
              <div className="flex flex-shrink w-[30%] items-center justify-between cursor-pointer">
                {/* Use Link component to handle navigation */}
                <Link
                  to="/"
                  className="flex items-center"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <img
                    className="h-16 w-auto"
                    src="/image/Vinesh_logo.png"
                    alt="Vinesh"
                  />
                </Link>
              </div>
              {/* Navigation Bar for Large Screens */}
              <div className="hidden  w-[70%]  items-center sm:block">
                <div className="flex justify-end ml-4 items-center w-[98%] space-x-2">
                  {navigation.map((item) => (
                    <NavLink
                      key={item.name}
                      to={item.href}
                      activeClassName="text-fontColor text-lg font-semibold"
                      className={`rounded-md px-2 items-center pt-6 text-sm font-medium ${
                        item.current ? "text-fontColor font-bold text-xl" : ""
                      }`}
                    >
                      {item.name}
                    </NavLink>
                  ))}
                </div>
              </div>
            </div>

            {/* Navigation Button for Small Screens */}
            <div className="flex sm:hidden">
              <button
                onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                className="px-4 py-2 rounded-md text-fontColor hover:text-fontColor"
              >
                <FaBars />
              </button>
            </div>
          </div>

          {isMobileMenuOpen && isSmallScreen ? (
            <div className="fixed inset-0 z-20">
              <div
                className="flex sm:hidden border-b-[0.5px]"
                onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
              >
                <button className="px-4 py-8  z-40 rounded-md text-fontColor hover:text-fontColor"></button>
              </div>
              <div className="absolute top-18 right-0 bg-background  z-10 sm:hidden  w-[70%] items-top h-screen flex justify-center">
                <div className="flex flex-col w-[100%]  space-y-0">
                  {navigation.map((item) => (
                    <NavLink
                      key={item.name}
                      to={item.href}
                      activeClassName="text-fontColor w-[100%]  font-bold text-xl"
                      className={` px-3  border-b-[0.5px] py-4 w-[100%] items-center text-center text-sm font-medium ${
                        item.current ? "text-fontColor font-bold text-xl" : ""
                      }`}
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      {item.name}
                    </NavLink>
                  ))}
                </div>
              </div>
              <div
                className={`w-full z-10 h-full bg-black opacity-50 ${
                  isMobileMenuOpen ? "block" : "hidden"
                }`}
                onClick={() => setMobileMenuOpen(false)}
              />
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default NavigationBar;
